module.exports = __webpack_public_path__ + "img/hauskraeutchesgarten_2.bb25ec80.jpg";